import React from "react"

interface IPropsFromParent {
  children: React.ReactNode
  className?: string
  width?: string
}

type IProps = IPropsFromParent

const DetailsCardInner: React.FC<IProps> = ({
  children,
  className,
  width = "w-2/3"
}: IProps): JSX.Element => {
  const defaultClasses = [
    "flex-1",
    "flex",
    "flex-col",
    "sm:flex-row",
    "mb-2",
    "text-center",
    "sm:text-left",
    "sm:w-full",
    `md:${width}`,
    "md:mb-0",
    "md:mr-4",
    "items-center"
  ]

  const propClasses = className ? className.split(" ") : []
  const allClasses = [...defaultClasses, ...propClasses].join(" ")

  return (
    <div className={allClasses}>
      {children}
    </div>
  )
}

export default DetailsCardInner
